import React, { useState } from 'react'
import ReactHtmlParser from 'react-html-parser'

import * as S from './styles'
import Tooltip from 'src/components/Tooltip'

function CardPlan({ item, blur, section, plans }) {
	const [currentTooltip, setCurrentTooltip] = useState('')
	const { benefits, title, price, newPrice } = item.fields

	const titleFormatted = 'Por apenas {price} ao mês'.replace('{price}', `<span>R$5</span>`)

	const benefitTextFormatted = (text) => {
		return ReactHtmlParser(text)
	}

	function selectTooltip(text) {
		if(text === currentTooltip) setCurrentTooltip('')
		else setCurrentTooltip(text)
	}

	const textWithIcon = (text) => {
		return text.replace('{icon}', '<img src="/bradescoclassic/assets/info_icon.png" />')
	}

	return (
		<S.Container>
			<S.Title>{ReactHtmlParser(titleFormatted)}</S.Title>
			<S.Benefits>
					{benefits.map((benefit, index) => (
						<S.Item
							key={benefit.text}
						>
							<img src="/bradescoclassic/assets/check.svg" alt="check" />
							<S.Benefit bold={benefit.isBold} blur={blur} onClick={() => selectTooltip(benefit.text)}>
								{benefitTextFormatted(textWithIcon(benefit.text))}
									{currentTooltip === benefit.text && benefit.tooltip && (
										<Tooltip title={benefit.tooltip.title} description={benefit.tooltip.description} />
									)}
							</S.Benefit>
						</S.Item>
					))}
				</S.Benefits>
		</S.Container>
	)
}

export default CardPlan
